(function(){
  document.querySelectorAll('.sp-pd-faq-q').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.closest('.sp-pd-faq-item');
      var wasOpen = item.classList.contains('sp-pd-open');
      item.closest('.sp-pd-faq-list').querySelectorAll('.sp-pd-faq-item').forEach(function(i){
        i.classList.remove('sp-pd-open');
      });
      if(!wasOpen) item.classList.add('sp-pd-open');
    });
  });
})();